module.exports = __webpack_public_path__ + "img/file-text.361d7ed1.png";